import { cls } from "@wss/cls";
import React from "react";
import Icon from "~/common/Icons/Standard";
const VerifiedPurchaseBadge = () => <div className={cls("pt-2", "flex", "items-center")} data-sentry-component="VerifiedPurchaseBadge" data-sentry-source-file="index.tsx">
    <div className={cls("text-green-400", "flex")}>
      <Icon name="verified-shield" className={cls("h-4", "w-4")} data-sentry-element="Icon" data-sentry-source-file="index.tsx" />
    </div>
    <p className="text-sm m-0 text-gray-800 inline-block font-normal ml-1 leading-4">
      Verified Purchase
    </p>
  </div>;
export default VerifiedPurchaseBadge;